function formatWarehouseLocation(warehouse) {
  if (!warehouse) {
    return '-';
  }

  const location = warehouse.location;
  const warehouseLabel = warehouse.code
    ? `${warehouse.code} ${warehouse.name ?? ''}`.trim()
    : (warehouse.name ?? '-');

  if (!location) {
    return warehouseLabel;
  }

  const locationLabel = location.code
    ? `${location.code} ${location.name ?? ''}`.trim()
    : (location.name ?? '-');

  return `${warehouseLabel} → ${locationLabel}`;
}

function formatQtyValue(qty) {
  if (!qty) {
    return '-';
  }

  const parts = [];

  if (qty.returnedQty != null) {
    parts.push(String(qty.returnedQty));
  }
  if (qty.pendingQty != null && Number(qty.pendingQty) > 0) {
    parts.push(`待 ${qty.pendingQty}`);
  }
  if (qty.sourceQty != null && parts.length === 0) {
    parts.push(String(qty.sourceQty));
  }

  return parts.length > 0 ? parts.join('／') : '-';
}

function formatUnitLabel(unit) {
  if (!unit) {
    return '-';
  }
  return [unit.code, unit.name].filter(Boolean).join(' ') || '-';
}

export function buildStockReturnLineColumns() {
  return [
    {
      id: 'stockNo',
      header: '來源庫存',
      size: 140,
      enableSorting: false,
      cell: ({ row }) => row.original.invStock?.stockNo
        || row.original.invStock?.id
        || '-',
    },
    {
      id: 'mtr',
      header: '物料',
      size: 180,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => {
        const mtr = row.original.mtr;
        if (!mtr) {
          return '-';
        }
        return (
          <div>
            <p>{mtr.name || '-'}</p>
            <p className="text-xs font-mono text-gray-500">{mtr.mtrNo || ''}</p>
          </div>
        );
      },
    },
    {
      id: 'qty',
      header: '數量',
      size: 100,
      enableSorting: false,
      meta: { cellClassName: 'text-right' },
      cell: ({ row }) => formatQtyValue(row.original.qty),
    },
    {
      id: 'unit',
      header: '單位',
      size: 88,
      enableSorting: false,
      cell: ({ row }) => formatUnitLabel(row.original.unit),
    },
    {
      id: 'sourceWarehouse',
      header: '來源倉',
      size: 160,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => formatWarehouseLocation(row.original.sourceWarehouse),
    },
    {
      id: 'targetWarehouse',
      header: '目的倉',
      size: 160,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => formatWarehouseLocation(row.original.targetWarehouse),
    },
    {
      id: 'remark',
      header: '備註',
      size: 140,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => row.original.remark || '-',
    },
  ];
}
